import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  formWrapper: {
    maxWidth: 320,
  },
}));
